export default __webpack_public_path__ + "static/media/download-image.77fc4268.jpg";